import type { ReactNode } from 'react'

/**
 * Keyboard-key chip used in shortcut hints + the shortcuts modal.
 * Pure presentational; size + spacing chosen to nest cleanly inside buttons.
 */
export function Kbd({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={
        'inline-flex items-center justify-center min-w-[22px] h-[20px] px-1.5 ' +
        'rounded-md bg-[#f1f5f9] dark:bg-[#334155] ' +
        'border border-[#e2e8f0] dark:border-[#475569] ' +
        'border-b-2 text-[11px] font-mono text-[#475569] dark:text-[#cbd5e1] leading-none ' +
        className
      }
    >
      {children}
    </kbd>
  )
}
